/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isNumber, isString } from "@adapptio/lib-shared";

const VALID_IDENTIFIER_REGEX = /^[a-zA-Z_$][a-zA-Z_0-9$]*$/;
const SINGLE_QUOTE_REGEX = /'/g;

function isValidIdentifier(id: unknown): boolean {
	return isString(id) && VALID_IDENTIFIER_REGEX.test(id);
}

function escapeSingleQuotes(id: string): string {
	return id.replace(SINGLE_QUOTE_REGEX, "\\'");
}

export function serializeDataKey(id: string | number): string {
	if (isNumber(id)) {
		return `[${id}]`;
	}

	if (isValidIdentifier(id)) {
		return id;
	}

	return `'${escapeSingleQuotes(id)}'`;
}
